import ChapterDisplay from './ChapterDisplay';
import Comments from './Comments';

export default function Capitulo7() {
    const section = 'el-mictlan';
    const title = 'El Mictlán';
    const description = '';
    const text = '<p>Después de viajar en una estela de rosas, llegué a la estación central de las estelas. ¡Era un lugar enorme, lleno de seres raros! Salimos de ahí y llegamos al Mictlán, una ciudad increíble que flota en el agua.</p><p><b>El Mictlán</b> es para los mexicas el lugar donde descansan las almas de las personas que mueren de forma natural, ¡pero no es un infierno! Es como un viaje difícil de nueve niveles que dura cuatro años, lleno de pruebas como pasar entre montañas que chocan o cruzar un río. Al final, las almas llegan con los señores del Mictlán y se disuelven en la paz eterna. Para mí, esta creencia nos enseña que la muerte no era algo que diera miedo, sino una parte más del ciclo de la vida. Me parece muy bonito que vieran la muerte no como un final, sino como un viaje de transformación donde lo más importante no eran tus riquezas, sino haber vivido una buena vida.</p><p> Crucé un río gigante con la ayuda de Taquito que se hizo grandote, donde vive un monstruo, muy buena onda, llamado <b>Xochitonal</b>: tiene forma de lagarto gigante que, según la leyenda mexica, cuida el noveno nivel del Mictlán, el inframundo. Para poder llegar al descanso eterno, las almas tienen que cruzar sobre su lomo. Pero no es malo, es más bien un guardián que pone una última prueba. Lo interesante es que su piel está cubierta de diseños como los de un cocodrilo, que son como un mapa o un códice.</p><p>Luego, Tinskani me echó agua de una fuente y se transformó en una mujer guapísima. Me contó que se lleva mal con el señor del Mictlán por una chava llamada Xochiquétzal (¡eso huele a chisme!).</p><p>Antes de avanzar más, Tinskani tomó un poco más de agua de esa fuente dedidacada a <b>Chalchiuhtlicue</b>, la diosa mexica del agua, de los ríos, los lagos y del mar. Su nombre significa "la de la falda de jade", porque imaginaban que el agua tranquila y pura brillaba como una piedra preciosa verde.</p><p>Finalmente, subimos una pirámide gigante y nos perdimos en una neblina. Taquito me guió hasta una estatua enorme de un señor con una calavera. La estatua estaba encadenada y se veía muy triste. Le pregunté a Taquito quién era, pero no me dijo, ¡se puso triste!</p><p>¡Qué misterio! ¿Quién crees que sea esa estatua? ¡Necesito saberlo!</p>';
    const image = 'https://www.diadelavida.com/images/chapters/deco_capitulo7.png';
    const image_number = 'https://www.diadelavida.com/images/numbers/7.png'
    const image_size = 'contain';
    const image_position = 'center';
    const image_height = 600;
    const comments_prompt = '¿Haz viajado en trajinera alguna vez? ¿Qué fue lo que más te gustó? ¡Deja tu comentario!';

    const images = [
        {
            id: 1,
            src: 'https://www.diadelavida.com/images/chapters/capitulo7_main.jpg',
            alt: 'Noche de Muertos | Día de la Vida - Capítulo 7',
            description: '¡Esta ciudad es increíble!'
        },
        {
            id: 2,
            src: 'https://diadelavida.com/images/cards/card_xochitonal_01.jpg',
            alt: 'Noche de Muertos | Día de la Vida - Capítulo 7',
            description: 'Aunque al principio me asustó, ¡Xochitonal es muy amigable!'
        },
    ];

    return (
        <div>
            <ChapterDisplay
                section={section}
                title={title}
                description={description}
                text={text}
                image={image}
                imageSize={image_size}
                imagePosition={image_position}
                imageHeight={image_height}
                images={images}
                imageNumber={image_number}
            />
            <div id='users-comments'>
                <div className="comments-deco"></div>
                <div className="container">
                    <div className="row">
                        <Comments sectionId={section} commentsPrompt={comments_prompt} />
                    </div>
                </div>
            </div>
        </div>
    );
}